import React, {useEffect, useState} from 'react'
import { BiFilter } from 'react-icons/bi'
import ico from "../../../assets/searchIcon/search.svg"
import JobCard from '../../components/Cards/JobCard'
import { JOB_API_END_POINT as api } from '../../../../utils/constant'
import axios from 'axios'
import { useSelector } from 'react-redux'
import JobCardSkeleton from '../../components/Skeletton/JobCardSkeleton'
import CandidateModal from '../../components/Modal/CandidateModal'

const Recruitment = () => {

    const [offers, setOffers] = useState([])
    const [loading, setloading] = useState(true)
    const {user} = useSelector(store=>store.user);
    const formDataToSend = new FormData();
    formDataToSend.append("user_id", 2);
    const [selectedStatus, setSelectedStatus] = useState('Tous');

    useEffect(() => {
      // Fetch data from JSON or API
      const fetchPostData = async () => {
       
      await axios.get(`${api}/recruiter/all?user_id=2`)
      .then(response => {
        setOffers(response.data);
        setloading(false)
      })
      .catch(error => {
        setloading(false)
      })
    }
    fetchPostData()
      
    }, [])

  return (
    <div className='layout-1'>
      <h1 className='font-semibold mb-6 text-start'>Recrutement</h1>
      <div className="flex sticky top-0 border-b w-full my-4 text-sm bg-white pt-2">
        {['Tous', 'En attente', 'Entretien', 'Réfusé', 'Embauché'].map(status => (
          <button
            key={status}
            className={`px-6 py-2 font-bold ${selectedStatus === status ? 'border-b-2 border-black' : 'hover:text-primary-black'}`}
            onClick={() => setSelectedStatus(status)}
          >
            {status}
          </button>
        ))}
      </div>
      <div className=" flex justify-between items-center mb-4">
         <div className="relative flex items-center w- h-10 rounded-lg   overflow-hidden border ">
          <div className="grid place-items-center h-full w-12 text-gray-300">
              <img src={ico} alt="serachbtn" />
          </div>
          <input
          className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
          type="text"
          id="search"
          placeholder="Mot clé..." 
          // onChange={(e)=>setFormData({...formData, keyword: e.target.value})}
          /> 
        </div>
        <div className="flex gap-2 ">
       
        <button className="px-4 py-2 font-medium border text-[#24292F] hover:bg-primary-black hover:text-white rounded-md focus:outline-none text-sm flex gap-1 items-center justify-between">
        <BiFilter className='w-5 h-5'/>
        Filtrer
        </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 min-[1500px]:grid-cols-3 gap-4">
      {loading
        ? Array(3) // Affiche 6 skeletons en guise de prévisualisation
            .fill(null)
            .map((_, index) => <JobCardSkeleton key={index} />)
        : offers.map((job) => <JobCard key={job.id} item={job} />)}
</div>
</div>

  )
}

export default Recruitment